/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import { companiesPayload } from '../../../../../../api/models/response/CompaniesPayload'
import { GamePayload } from '../../../../../../api/models/response/GamePayload'
import { ChampionshipPayload } from '../../../../../../api/models/response/ChampionshipPayload'

type Props = {
  item: ChampionshipPayload
}

const IsNotifiedCell: FC<Props> = ({item}) =>
{
  
  return (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='d-flex flex-column'>
      {/* <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {company.regNumber}
      </a> */}
      <span> {item?.isNotified ? 'Yes' : 'No'}</span>
    </div>
  </div>
)
} 
export {IsNotifiedCell}
